<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="consumedItems"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
    :hasTableTitle="true"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :stockAdjustment="stockAdjustment"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :stockAdjustment="stockAdjustment"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :stockAdjustment="stockAdjustment"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      tableHeaders: [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        // { text: "Qtd. Atual", align: "left", sortable: true, value: "quantityBeforeConsumption" },
        { text: "Qtd. Removida", align: "left", sortable: true, value: "quantity" },
        // { text: "Qtd. Final", align: "left", sortable: true, value: "quantityAfterConsumption" },
        { text: "Unidade", align: "left", sortable: true, value: "item.unit.name" },
        // { text: "Und.", align: "left", sortable: true, value: "item.unit.name" },
        // { text: "R$ Total", align: "left", sortable: true, value: "totalPrice" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        // { field: 'price', mask: 'currency_10d' },
        // { field: 'quantityBeforeConsumption', mask: 'number' },
        { field: 'quantity', mask: 'number' },
        // { field: 'quantityAfterConsumption', mask: 'number' },
        // { field: 'totalPrice', mask: 'currency'}
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    consumedItems: { 
      type: Array,
      default: () => []
    },
    stockAdjustment: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Item de ajuste de saída de estoque"
    },
    modelNamePlural: {
      type: String,
      default: "Itens de ajuste de saída de estoque"
    },
  },
  created() {
  },
  methods: {
    entryUpdated: function(editedEntry){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(editedEntry){
      this.consumedItems.push(editedEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(editedEntry){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
  }
};
</script>

<style scoped></style>
